import { render, staticRenderFns } from "./ProgressSimple.vue?vue&type=template&id=0f585bb2&"
import script from "./ProgressSimple.vue?vue&type=script&lang=js&"
export * from "./ProgressSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports